<template>
  <div class="content_main">
    <div style="margin-top: 10px">
      <!-- <a-button type="primary" @click="application"> 评审费申请 </a-button> -->
      <a-button type="primary" @click="exp"> 数据导出 </a-button>
    </div>
    <div class="content_main_top">
      <a-input
        allowClear
        class="a_input_self margin_self"
        v-model="queryParam.applyCode"
        placeholder="审批编号"
        @keyup.enter.native="query"
      />
      <a-input
        allowClear
        class="a_input_self margin_self"
        v-model="queryParam.applyUserName"
        placeholder="申请人"
        @keyup.enter.native="query"
      />
      <a-range-picker
        valueFormat="YYYY-MM-DD"
        style="margin-right: 10px; width: 240px"
        allowClear
        :value="dates"
        @change="onChange"
        @keyup.enter.native="query"
        :placeholder="['申请开始时间', '申请结束时间']"
      />
      <a-select
        placeholder="审批状态"
        class="a_input_self margin_self"
        v-model="queryParam.status"
        default-value="0"
        @keyup.enter.native="query"
      >
        <a-select-option :value="''">全部</a-select-option>
        <a-select-option v-for="(val, key) in status_apply" :key="key" :value="key">{{ val.txt }}</a-select-option>
      </a-select>
      <a-select
        placeholder="审批结果"
        class="a_input_self margin_self"
        v-model="queryParam.result"
        default-value="0"
        @keyup.enter.native="query"
      >
        <a-select-option :value="''">全部</a-select-option>
        <a-select-option v-for="(val, key) in resultMap" :key="key" :value="key">{{ val }}</a-select-option>
      </a-select>
      <a-button type="primary" @click="query"> 查询 </a-button>
      <a-button type="primary" ghost @click="result"> 重置 </a-button>
    </div>
    <div class="content_main_center_scroll" id="content_main_center_scroll">
      <a-table
        :columns="columns"
        :data-source="data"
        bordered
        :pagination="pagination"
        @change="handleTableChange"
        :scroll="{ y: scroll_y }"
      >
        <span slot="index" slot-scope="text, record, index">
          {{ (pagination.current - 1) * pagination.pageSize + index + 1 }}
        </span>
        <span slot="status" slot-scope="text" class="tag_class" :style="{ background: status_apply[text].color }">
          {{ status_apply[text].txt }}
        </span>
        <span slot="result" slot-scope="text" class="tag_class" :style="{ background: result_apply[text].color }">
          {{ result_apply[text].txt }}
        </span>
        <span slot="action" slot-scope="text, record">
          <a @click="handelAudit(record)">详情</a>
          <a-divider type="vertical" />
          <a @click="handFlow(record)">历史</a>
          <a-divider type="vertical" />
          <a :disabled="record.status !== 1" @click="cancel([record.procInstId])">撤销</a>
          <!-- <a-divider type="vertical" />
					<a :disabled="record.status === 1" @click="delByIds([record.buId])">删除</a> -->
        </span>
      </a-table>
    </div>
    <a-modal v-model="appvisible" title="评审费申请" @ok="appOk" width="60%" :maskClosable="false">
      <a-form-model ref="ruleForm" :rules="rules" :model="form" :labelCol="labelCol" :wrapperCol="wrapperCol">
        <a-row>
          <a-col :span="12">
            <a-form-model-item>
              <span class="spanClass" style="font-size: 16px; font-weight: 700; color: gray">表单信息</span>
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row>
          <a-form-model-item label="选择抄送人" :label-col="{ span: 3 }" :wrapper-col="{ span: 21 }">
            <ccChange :data="ccC" :money="moneY" @targetKeys="getdata" v-if="isRouterAlive" />
          </a-form-model-item>
        </a-row>
        <a-row>
          <a-col :span="8">
            <a-form-model-item label="隶属公司" prop="companyId">
              <a-select allowClear placeholder="隶属公司" @change="handlecompanyplan" v-model="form.companyId">
                <a-select-option :value="item.deptId" v-for="(item, index) in companylist" :key="index">
                  {{ item.title }}
                </a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
          <a-col :span="8">
            <a-form-model-item label="隶属部门" prop="deptId">
              <a-tree-select
                allowClear
                :treeData="deptTree"
                placeholder="隶属部门"
                :disabled="!this.form.companyId"
                v-model="form.deptId"
                treeDefaultExpandAll
              >
              </a-tree-select>
              <!-- <a-select allowClear v-model="form.deptId" placeholder="隶属部门" :disabled="!this.form.companyId">
								<a-select-option :value="item.dept_id" v-for="(item, index) in deptlist" :key="index">
									{{ item.dept_name }}
								</a-select-option>
							</a-select> -->
            </a-form-model-item>
          </a-col>
          <a-col :span="8">
            <a-form-model-item label="款项用途" prop="types">
              <a-select allowClear placeholder="款项用途" disabled @change="typesChange" v-model="form.types">
                <a-select-option :value="index" v-for="(item, index) in typesMap" :key="index">
                  {{ item }}
                </a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="8">
            <a-form-model-item label="付款事由" prop="paymentDetails">
              <a-input allowClear v-model="form.paymentDetails" placeholder="付款事由" />
            </a-form-model-item>
          </a-col>
          <a-col :span="8">
            <a-form-model-item label="付款方式" prop="paymentMode">
              <a-select allowClear placeholder="付款方式" v-model="form.paymentMode">
                <a-select-option :value="index" v-for="(item, index) in paymentMap" :key="index">
                  {{ item }}
                </a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
          <a-col :span="8">
            <a-form-model-item label="支付日期">
              <a-date-picker
                valueFormat="YYYY-MM-DD"
                allowClear
                :value="form.paymentDate"
                @change="paymentChange"
                placeholder="支付日期"
                style="width: 227px"
              />
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="8">
            <a-form-model-item label="支付对象" prop="paymentObject">
              <a-input allowClear v-model="form.paymentObject" placeholder="支付对象" />
            </a-form-model-item>
          </a-col>
          <a-col :span="8">
            <a-form-model-item label="开户行" prop="bankOfDeposit">
              <a-input allowClear v-model="form.bankOfDeposit" placeholder="开户行" />
            </a-form-model-item>
          </a-col>
          <a-col :span="8">
            <a-form-model-item label="银行账户" prop="bankAccount">
              <a-input allowClear v-model="form.bankAccount" placeholder="银行账户" />
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="8">
            <a-form-model-item label="特殊备注">
              <a-textarea
                :auto-size="{ minRows: 1, maxRows: 3 }"
                allowClear
                v-model="form.remark"
                placeholder="不能打印"
              />
            </a-form-model-item>
          </a-col>
        </a-row>
        <div v-if="form.types == 1" v-for="(item, index) in form.pays" :key="index">
          <a-row>
            <div class="pay_top">
              <span class="form_title" style="font-size: 16px; font-weight: 700; color: gray"
                >评审费{{ index + 1 }}</span
              >
              <a-icon class="close_icon" @click="close_detail(index)" v-if="form.pays.length > 1" type="close" />
            </div>
          </a-row>
          <a-row>
            <a-col :span="8">
              <a-form-model-item
                label="项目编号"
                :prop="'pays.' + index + '.projectCode'"
                :rules="{
                  required: true,
                  message: '请输入项目编号',
                  trigger: 'blur',
                }"
              >
                <a-input allowClear v-model="form.pays[index].projectCode" placeholder="项目编号" />
              </a-form-model-item>
            </a-col>
            <a-col :span="8">
              <a-form-model-item
                label="项目负责人"
                :prop="'pays.' + index + '.projectUser'"
                :rules="{
                  required: true,
                  message: '请输入项目负责人',
                  trigger: 'blur',
                }"
              >
                <a-input allowClear v-model="form.pays[index].projectUser" placeholder="项目负责人" />
              </a-form-model-item>
            </a-col>
            <a-col :span="8">
              <a-form-model-item
                label="客户名称"
                :prop="'pays.' + index + '.inspectedUnit'"
                :rules="{
                  required: true,
                  message: '请输入客户名称',
                  trigger: 'blur',
                }"
              >
                <a-input allowClear v-model="form.pays[index].inspectedUnit" placeholder="客户名称" />
              </a-form-model-item>
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="8">
              <a-form-model-item
                label="评审日期"
                :prop="'pays.' + index + '.reviewDate'"
                :rules="{
                  required: true,
                  message: '请选择评审日期',
                  trigger: 'change',
                }"
              >
                <a-date-picker
                  valueFormat="YYYY-MM-DD"
                  allowClear
                  v-model="form.pays[index].reviewDate"
                  placeholder="评审日期"
                  style="width: 227px"
                />
              </a-form-model-item>
            </a-col>
            <a-col :span="8">
              <a-form-model-item label="实际评审日期">
                <a-date-picker
                  valueFormat="YYYY-MM-DD"
                  allowClear
                  v-model="form.pays[index].actualReviewDate"
                  placeholder="实际评审日期"
                  style="width: 227px"
                />
              </a-form-model-item>
            </a-col>
            <a-col :span="8">
              <a-form-model-item
                label="评审费金额(元)"
                :prop="'pays.' + index + '.reviewAmount'"
                :rules="{
                  required: true,
                  message: '请输入评审费金额(元)',
                  trigger: 'blur',
                }"
              >
                <a-input
                  type="number"
                  allowClear
                  v-model="form.pays[index].reviewAmount"
                  @change="changeMoneyTotal"
                  placeholder="评审费金额"
                />
              </a-form-model-item>
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="8">
              <a-form-model-item
                label="专家人数"
                :prop="'pays.' + index + '.expertNum'"
                :rules="{
                  required: true,
                  message: '请输入专家人数',
                  trigger: 'blur',
                }"
              >
                <a-input type="number" allowClear v-model="form.pays[index].expertNum" placeholder="专家人数" />
              </a-form-model-item>
            </a-col>
            <a-col :span="8">
              <a-form-model-item label="备注">
                <a-input allowClear v-model="form.pays[index].remark" placeholder="备注" />
              </a-form-model-item>
            </a-col>
          </a-row>
        </div>
        <a-row v-if="form.types == 1">
          <div class="btn_last">
            <a-button type="primary" @click="add_detail"> 新增评审费明细 </a-button>
          </div>
        </a-row>
        <div v-if="form.types == 2" v-for="(item, index) in form.service" :key="index">
          <a-row>
            <div class="pay_top">
              <span class="form_title" style="font-size: 16px; font-weight: 700; color: gray"
                >服务费{{ index + 1 }}</span
              >
              <a-icon class="close_icon" @click="close_service(index)" v-if="form.service.length > 1" type="close" />
            </div>
          </a-row>
          <a-row>
            <a-col :span="8">
              <a-form-model-item
                label="项目编号"
                :prop="'service.' + index + '.projectCode'"
                :rules="{
                  required: true,
                  message: '请输入项目编号',
                  trigger: 'blur',
                }"
              >
                <a-input allowClear v-model="form.service[index].projectCode" placeholder="项目编号" />
              </a-form-model-item>
            </a-col>
            <a-col :span="8">
              <a-form-model-item
                label="受检单位"
                :prop="'service.' + index + '.inspectedUnit'"
                :rules="{
                  required: true,
                  message: '请输入受检单位',
                  trigger: 'blur',
                }"
              >
                <a-input allowClear v-model="form.service[index].inspectedUnit" placeholder="受检单位" />
              </a-form-model-item>
            </a-col>
            <a-col :span="8">
              <a-form-model-item
                label="合同金额(元)"
                :prop="'service.' + index + '.contractAmount'"
                :rules="{
                  required: true,
                  message: '请输入合同金额(元)',
                  trigger: 'blur',
                }"
              >
                <a-input allowClear v-model="form.service[index].contractAmount" placeholder="合同金额" />
              </a-form-model-item>
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="8">
              <a-form-model-item
                label="收款日期"
                :prop="'service.' + index + '.amountDate'"
                :rules="{
                  required: true,
                  message: '请选择收款日期',
                  trigger: 'change',
                }"
              >
                <a-date-picker
                  valueFormat="YYYY-MM-DD"
                  allowClear
                  @change="costChange2(index, $event)"
                  placeholder="收款日期"
                  style="width: 227px"
                />
              </a-form-model-item>
            </a-col>
            <a-col :span="8">
              <a-form-model-item
                label="支付金额(元)"
                :prop="'service.' + index + '.reviewAmount'"
                :rules="{
                  required: true,
                  message: '请输入支付金额(元)',
                  trigger: 'blur',
                }"
              >
                <a-input
                  allowClear
                  v-model="form.service[index].reviewAmount"
                  @change="changeMoneyTotal"
                  placeholder="支付金额"
                />
              </a-form-model-item>
            </a-col>
            <a-col :span="8">
              <a-form-model-item label="备注">
                <a-input allowClear v-model="form.service[index].remark" placeholder="备注" />
              </a-form-model-item>
            </a-col>
          </a-row>
        </div>
        <a-row v-if="form.types == 2">
          <div class="btn_last">
            <a-button type="primary" @click="add_service"> 新增服务费明细 </a-button>
          </div>
        </a-row>
        <div v-if="form.types == 3" v-for="(item, index) in form.other" :key="index">
          <a-row>
            <div class="pay_top">
              <span class="form_title" style="font-size: 16px; font-weight: 700; color: gray"
                >其他费用{{ index + 1 }}</span
              >
              <a-icon class="close_icon" @click="close_other(index)" v-if="form.other.length > 1" type="close" />
            </div>
          </a-row>
          <a-row>
            <a-col :span="8">
              <a-form-model-item
                label="费用明细"
                :prop="'other.' + index + '.amountDetails'"
                :rules="{
                  required: true,
                  message: '请输入费用明细',
                  trigger: 'blur',
                }"
              >
                <a-input allowClear v-model="form.other[index].amountDetails" placeholder="费用明细" />
              </a-form-model-item>
            </a-col>
            <a-col :span="8">
              <a-form-model-item
                label="支付金额(元)"
                :prop="'other.' + index + '.reviewAmount'"
                :rules="{
                  required: true,
                  message: '请输入支付金额(元)',
                  trigger: 'blur',
                }"
              >
                <a-input
                  allowClear
                  v-model="form.other[index].reviewAmount"
                  @change="changeMoneyTotal"
                  placeholder="支付金额"
                />
              </a-form-model-item>
            </a-col>
            <a-col :span="8">
              <a-form-model-item label="备注">
                <a-input allowClear v-model="form.other[index].remark" placeholder="备注" />
              </a-form-model-item>
            </a-col>
          </a-row>
        </div>
        <a-row v-if="form.types == 3">
          <div class="btn_last">
            <a-button type="primary" @click="add_other"> 新增其他费用明细 </a-button>
          </div>
        </a-row>
        <a-row>
          <a-col :span="8">
            <a-form-model-item label="总金额">
              <a-input disabled v-model="form.amountTotal" placeholder="请输入"></a-input>
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="24">
            <a-form-model-item label="附件" :label-col="{ span: 2 }" :wrapper-col="{ span: 22 }">
              <uploadImgJava :data="uploadDataImg" v-if="isRouterAlive" />
            </a-form-model-item>
          </a-col>
        </a-row>
      </a-form-model>
    </a-modal>
    <proc-flow-modal ref="modalflow" />
    <service-modal ref="servicemodal" :audit="false" />
  </div>
</template>

<script>
import { tree_all } from '@/api/purchase'
import { getDeptListEnable2 } from '@/api/system'
import { remove } from '@/api/assetmenag'
import { review_apply_code, review_apply_save, review_apply_list } from '@/api/financial'
import { delProcessIns, delBusiness } from '@/api/activiti'
import ProcFlowModal from '../activiti/modules/ProcFlowModal.vue'
import ServiceModal from '../activiti/modules/ServiceModal.vue'
import uploadImgJava from '@/components/module/uploadImgJava.vue'
import ccChange from '@/components/module/ccChange'
const columns = [
  {
    title: '序号',
    dataIndex: 'index',
    key: 'index',
    scopedSlots: {
      customRender: 'index',
    },
    width: 70,
    ellipsis: true,
  },
  {
    title: '审批编号',
    dataIndex: 'reviewCode',
    key: 'reviewCode',
    ellipsis: true,
  },
  {
    title: '申请人',
    dataIndex: 'userName',
    key: 'userName',
    ellipsis: true,
  },
  {
    title: '申请时间',
    dataIndex: 'createTime',
    key: 'createTime',
    ellipsis: true,
  },
  {
    title: '标题',
    dataIndex: 'title',
    key: 'title',
    ellipsis: true,
  },
  {
    title: '审批结果',
    dataIndex: 'result',
    key: 'result',
    scopedSlots: {
      customRender: 'result',
    },
    ellipsis: true,
  },
  {
    title: '审批状态',
    dataIndex: 'status',
    key: 'status',
    scopedSlots: {
      customRender: 'status',
    },
    ellipsis: true,
  },
  {
    title: '操作',
    dataIndex: 'action',
    scopedSlots: {
      customRender: 'action',
    },
  },
]
export default {
  components: {
    ProcFlowModal,
    ServiceModal,
    uploadImgJava,
    ccChange,
  },
  data() {
    return {
      rules: {
        companyId: [
          {
            required: true,
            message: '请选择隶属公司！',
          },
        ],
        deptId: [
          {
            required: true,
            message: '请选择部门！',
          },
        ],
        types: [
          {
            required: true,
            message: '请选择款项用途！',
          },
        ],
        paymentDetails: [
          {
            required: true,
            message: '请输入付款事由！',
          },
        ],
        paymentMode: [
          {
            required: true,
            message: '请选择付款方式！',
          },
        ],
        paymentObject: [
          {
            required: true,
            message: '请输入支付对象！',
          },
        ],
        bankOfDeposit: [
          {
            required: true,
            message: '请输入开户行！',
          },
        ],
        bankAccount: [
          {
            required: true,
            message: '请输入银行账户！',
          },
        ],
      },
      deptTree: [],
      columns,
      scroll_y: 150,
      dept_id: '',
      code: '',
      asset_sn: '',
      headers: {},
      fileList: [],
      removeList: [],
      defaultFileList: [],
      file_name: '',
      upload: {
        asset_sn: '',
        dept_id: '',
      },
      pagination: {
        current: 1,
        pageSize: 10,
        total: 0,
        pageSizeOptions: ['10', '20', '30', '40', '50'],
        showLessItems: true,
        showSizeChanger: true,
      },
      labelCol: {
        span: 9,
      },
      wrapperCol: {
        span: 15,
      },
      labelCol2: {
        span: 2,
      },
      wrapperCol2: {
        span: 22,
      },
      isRouterAlive: true,
      appvisible: false,
      companylist: [],
      form: {
        cc: [],
        deptId: undefined,
        companyId: undefined,
        types: undefined,
        paymentDetails: '',
        paymentMode: undefined,
        paymentDate: '',
        paymentObject: '',
        bankOfDeposit: '',
        bankAccount: '',
        amountTotal: '',
        remark: '',
        pays: [
          {
            projectCode: '',
            inspectedUnit: '',
            reviewDate: '',
            reviewAmount: '',
            expertNum: '',
            actualReviewDate: '',
            remark: '',
            projectUser: '',
          },
        ],
        service: [
          {
            projectCode: '',
            inspectedUnit: '',
            contractAmount: '',
            amountDate: '',
            reviewAmount: '',
            remark: '',
          },
        ],
        other: [
          {
            amountDetails: '',
            reviewAmount: '',
            remark: '',
          },
        ],
      },
      deptlist: [],
      queryParam: {},
      dates: [],
      uploadDataImg: {
        code: '',
        type: 'review',
      },
      ccC: 'review',
      moneY: '',
    }
  },
  created() {
    tree_all().then((res) => {
      if (res.code == 200) {
        this.companylist = res.data[0]
      } else {
        this.$message.error(res.msg)
      }

      // this.companylist.unshift({
      // 	dept_id: 0,
      // 	dept_name: '所有公司',
      // 	child_lis: [],
      // })
    })
    this.get_sel()
  },
  mounted() {
    this.$nextTick(() => {
      var max_h = $('#content_main_center_scroll').height()
      setTimeout(() => {
        this.scroll_y = max_h - $('.ant-table-header').height() - 100
      }, 1000)
    })
  },
  methods: {
    buildtree2(list, arr, parentId) {
      list.forEach((item) => {
        if (item.parentId === parentId) {
          var child = {
            key: item.deptId,
            value: item.deptId, // value是给modal的select用的，2者属性不一样
            title: item.deptName,
            scopedSlots: {
              title: 'title',
            },
            children: [],
          }
          this.buildtree2(list, child.children, item.deptId)
          if (child.children.length === 0) {
            delete child.children
          }
          arr.push(child)
        }
      })
    },
    changeMoneyTotal() {
      this.form.amountTotal = 0
      if (this.form.types == 1) {
        this.form.pays.forEach((item) => {
          this.form.amountTotal += Number(item.reviewAmount)
        })
      } else if (this.form.types == 2) {
        this.form.service.forEach((item) => {
          this.form.amountTotal += Number(item.reviewAmount)
        })
      } else if (this.form.types == 3) {
        this.form.other.forEach((item) => {
          this.form.amountTotal += Number(item.reviewAmount)
        })
      }
      this.form.amountTotal = this.form.amountTotal.toFixed(2)
      this.moneY = this.form.amountTotal
    },
    getdata(data) {
      this.form.cc = data
    },
    handelAudit(record) {
      this.$refs.servicemodal.show({
        businessKey: record.buId,
        procInstId: record.procInstId,
        procDefKey: 'review',
        recordNumber: 1
      })
    },
    //历史
    handFlow(row) {
      var obj = {
        procInstId: row.procInstId,
        procDefKey: row.procDefKey,
      }
      this.$refs.modalflow.show(obj)
    },
    // 撤销
    cancel(ids) {
      console.log(ids)
      // const idstr = ids.map(r => { return '\'' + r + '\'' }).join('')
      delProcessIns({
        ids: ids.join(','),
        reason: '主动撤销',
      }).then((res) => {
        if (res.code === 200) {
          this.$message.success('撤销成功')
          this.get_sel()
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    delByIds(ids) {
      // const idstr = ids.map(r => { return '\'' + r + '\'' }).join('')
      delBusiness({
        ids: ids.join(','),
      }).then((res) => {
        if (res.code === 200) {
          this.$message.success('删除成功')
          this.get_sel()
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    typesChange() {
      this.form.pays = [
        {
          projectCode: '',
          inspectedUnit: '',
          reviewDate: '',
          reviewAmount: '',
          expertNum: '',
          actualReviewDate: '',
          remark: '',
          projectUser: '',
        },
      ]
      this.form.service = [
        {
          projectCode: '',
          inspectedUnit: '',
          contractAmount: '',
          amountDate: '',
          reviewAmount: '',
          remark: '',
        },
      ]
      this.form.other = [
        {
          amountDetails: '',
          reviewAmount: '',
          remark: '',
        },
      ]
      this.changeMoneyTotal()
    },
    paymentChange(date) {
      this.form.paymentDate = date
    },
    costChange(index, date) {
      this.form.pays[index].reviewDate = date
    },
    costChange2(index, date) {
      this.form.service[index].amountDate = date
    },
    onChange(date, dateString) {
      this.dates = date
      this.queryParam.start_date = date[0]
      this.queryParam.end_date = date[1]
    },
    //新增一条明细
    add_detail() {
      this.form.pays.push({
        projectCode: '',
        inspectedUnit: '',
        reviewDate: '',
        reviewAmount: '',
        expertNum: '',
        actualReviewDate: '',
        remark: '',
        projectUser: '',
      })
    },
    add_service() {
      this.form.service.push({
        projectCode: '',
        inspectedUnit: '',
        contractAmount: '',
        amountDate: '',
        reviewAmount: '',
        remark: '',
      })
    },
    add_other() {
      this.form.other.push({
        amountDetails: '',
        reviewAmount: '',
        remark: '',
      })
    },
    //删除明细
    close_detail(index) {
      this.form.pays.splice(index, 1)
      this.changeMoneyTotal()
    },
    close_service(index) {
      this.form.service.splice(index, 1)
      this.changeMoneyTotal()
    },
    close_other(index) {
      this.form.other.splice(index, 1)
      this.changeMoneyTotal()
    },
    handlecompanyplan(value) {
      this.deptTree = []
      this.deptlist = []
      this.form.deptId = undefined
      this.$nextTick(() => {
        getDeptListEnable2().then((res) => {
          const data = res.rows
          if (data.length > 0) {
            const min = Math.min(...data.map((m) => m.parentId))
            this.buildtree2(data, this.deptTree, this.form.companyId)
          }
        })
      })
      // this.companylist.forEach((item) => {
      // 	if (item.dept_id == this.form.companyId) {
      // 		this.deptlist = item.child_lis
      // 	}
      // })
    },
    appOk() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          if (this.form.types == 1) {
            this.form['bizReviewInfos'] = this.form.pays
          } else if (this.form.types == 2) {
            this.form['bizReviewInfos'] = this.form.service
          } else if (this.form.types == 3) {
            this.form['bizReviewInfos'] = this.form.other
          }
          this.form.title = this.$store.getters.userInfo.userName
          this.form.reviewCode = this.code
          this.form.cc = this.form.cc.length ? this.form.cc.join(',') : ''
          console.log(this.form)
          review_apply_save(this.form).then((res) => {
            if (res.code === 200) {
              this.$message.success('保存成功')
              this.$emit('ok')
              this.appvisible = false
              this.get_sel()
            } else {
              this.$message.error(res.msg)
              this.isRouterAlive = false
              this.$nextTick(() => {
                this.isRouterAlive = true
              })
            }
          })
        }
      })
    },
    application() {
      this.appvisible = true
      this.isRouterAlive = false
      this.$nextTick(() => {
        this.isRouterAlive = true
      })
      this.form = {
        deptId: undefined,
        companyId: undefined,
        types: undefined,
        paymentDetails: '',
        paymentMode: undefined,
        paymentDate: '',
        paymentObject: '',
        bankOfDeposit: '',
        bankAccount: '',
        amountTotal: '',
        remark: '',
        pays: [
          {
            projectCode: '',
            inspectedUnit: '',
            reviewDate: '',
            reviewAmount: '',
            expertNum: '',
            actualReviewDate: '',
            remark: '',
            projectUser: '',
          },
        ],
        service: [
          {
            projectCode: '',
            inspectedUnit: '',
            contractAmount: '',
            amountDate: '',
            reviewAmount: '',
            remark: '',
          },
        ],
        other: [
          {
            amountDetails: '',
            reviewAmount: '',
            remark: '',
          },
        ],
      }
      this.form.types = '1'
      review_apply_code().then((res) => {
        this.code = res.data
        this.uploadDataImg.code = res.data
      })
    },
    get_sel() {
      review_apply_list({
        pageSize: this.pagination.pageSize,
        pageNum: this.pagination.current,
        status: this.queryParam.status,
        result: this.queryParam.result,
        userName: this.queryParam.applyUserName,
        reviewCode: this.queryParam.applyCode,
        createTime1: this.queryParam.start_date,
        createTime2: this.queryParam.end_date,
      }).then((res) => {
        const pagination = { ...this.pagination }
        pagination.total = res.total
        this.pagination = pagination
        this.data = res.rows
      })
    },
    //改变分页
    handleTableChange(pagination, filters, sorter) {
      this.pagination.current = pagination.current
      this.pagination.pageSize = pagination.pageSize
      this.get_sel()
    },
    query() {
      this.pagination.current = 1
      this.get_sel()
    },
    result() {
      this.queryParam = {}
    },
  },
}
</script>

<style>
.btn_last {
  width: 100%;
  float: left;
  display: flex;
  justify-content: flex-end;
  align-items: flex-start;
}

.pay_top {
  width: 100%;
  float: left;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.form_title {
  margin-left: 15px;
  margin-bottom: 15px;
  font-size: 17px;
  color: #999;
}

.close_icon {
  font-size: 20px;
  color: red;
  cursor: pointer;
}
</style>
